<template>
  <div>
    <div class="content-wrapper">
      <div class="content-header">
        <div
          class="d-flex align-items-center"
          style="border-bottom: 1px solid #5c4a4a17; margin: auto !important"
        >
          <div class="row">
            <div class="col-sm-6 d-flex flex-column align-items-baseline">
              <h1 class="m-0 text-dark">Drip Setup</h1>
              <ol class="breadcrumb float-sm-left">
                <router-link
                  tag="li"
                  class="breadcrumb-item"
                  :to="{ name: 'Home' }"
                  >Home</router-link
                >
                <router-link
                  tag="li"
                  class="breadcrumb-item"
                  :to="{ name: 'Dashboard' }"
                  >Dashboard</router-link
                >
                <li class="breadcrumb-item active">Drip Setup</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="container" style="padding: 0 25px">
        <div class="row border my-4">
          <div
            class="col-12 border-bottom py-2 text-left"
            style="font-size: 11px"
          >
            SET APP
          </div>
          <div class="col-md-6 col-sx-12 text-left">
            <!-- Information For Creating Campaign -->
            <div>
              <!-- Title -->
              <div class="form-group">
                <label for="title" class="font-weight-bolder"
                  >Title<em class="asterisk">*</em></label
                >
                <v-text-field
                  type="text"
                  id="title"
                  class="pt-0"
                  :class="{ errorInput: error }"
                  placeholder="Title"
                  v-model="recurringDrips.title"
                  :rules="[rules.titleCounter, rules.required]"
                  counter
                  solo
                ></v-text-field>
                <Emoji
                  :topStyleBlock="82"
                  :rightStyleBlock="12"
                  :topStyleIcon="54"
                  :rightStyleIcon="15"
                  @addEmoji="(emoji) => (this.recurringDrips.title += emoji)"
                />
              </div>
              <!-- Message -->
              <div class="form-group position-relative">
                <label for="message" class="font-weight-bolder">Message</label>
                <v-text-field
                  type="text"
                  id="message"
                  class="pt-0"
                  :class="{ errorInput: error }"
                  placeholder="Message"
                  v-model="recurringDrips.body"
                  :rules="[rules.bodyCounter]"
                  counter
                  solo
                ></v-text-field>
                <Emoji
                  :topStyleBlock="70"
                  :rightStyleBlock="0"
                  :topStyleIcon="43"
                  :rightStyleIcon="7"
                  @addEmoji="(emoji) => (this.recurringDrips.body += emoji)"
                />
              </div>
              <!-- URL -->
              <div class="form-group">
                <label for="url" class="font-weight-bolder">URL</label>
                <v-text-field
                  type="text"
                  id="url"
                  class="pt-0"
                  :class="{ errorInput: error }"
                  placeholder="URL"
                  v-model="recurringDrips.url"
                  counter
                  solo
                ></v-text-field>
              </div>
              <!-- Custom Icon -->
              <div class="form-group">
                <label for="campaign" class="font-weight-bolder"
                  >Custom Icon</label
                >
                <v-file-input
                  :clearable="false"
                  show-size
                  truncate-length="15"
                  id="icon"
                  accept="image/png, image/jpeg"
                  @change="iconImgForPush"
                ></v-file-input>
              </div>
            </div>
            <!-- Additional Customization -->
            <div
              style="border-top: 1px solid #5c4a4a17; margin: auto !important"
            >
              <h4 class="mt-3">Additional Customization</h4>
              <!-- Add Large Image -->
              <div class="form-group d-flex flex-row">
                <input
                  type="checkbox"
                  id="lgImage"
                  @click="shwLargeImg = !shwLargeImg"
                />
                <div class="d-flex flex-column w-100">
                  <label for="large-img" class="font-weight-bolder"
                    >Add Large Image</label
                  >
                  <div class="overflow-hidden">
                    <transition
                      class="animate__faster"
                      enter-active-class="animate__animated animate__slideInDown animate__faster"
                      leave-active-class="animate__animated animate__slideOutUp animate__faster"
                    >
                      <div v-if="shwLargeImg">
                        <v-file-input
                          :clearable="false"
                          show-size
                          truncate-length="15"
                          id="lgImg"
                          accept="image/png, image/jpeg"
                          @change="lgImgForPush"
                        ></v-file-input>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
              <!-- Action Buttons -->
              <div class="form-group d-flex flex-column mb-0">
                <div class="d-flex flex-row-reverse justify-content-end">
                  <transition
                    class="animate__faster"
                    enter-active-class="animate__animated animate__fadeIn animate__faster"
                    leave-active-class="animate__animated animate__fadeOut animate__faster"
                  >
                    <select
                      name="btns"
                      class="ml-2 px-2 blue"
                      style="color: #fff"
                      v-if="shwActionBtns"
                      v-on:change="shwBtn2 = !shwBtn2"
                    >
                      <option value="1">1 Button</option>
                      <option value="2">2 Buttons</option>
                    </select>
                  </transition>
                  <label
                    for="actionBtns"
                    class="font-weight-bolder flex-row-reverse justify-content-end"
                    >Action Buttons</label
                  >
                  <input
                    type="checkbox"
                    id="actionBtns"
                    @click="
                      shwActionBtns = !shwActionBtns;
                      shwBtn1 = !shwBtn1;
                      shwBtn2 = false;
                    "
                  />
                </div>
                <transition-group
                  tag="div"
                  class="d-flex flex-column mt-3 mb-3"
                  enter-active-class="animate__animated animate__slideInLeft animate__faster"
                  leave-active-class="animate__animated animate__slideOutLeft animate__faster"
                >
                  <div
                    v-if="shwActionBtns"
                    :key="0"
                    class="d-flex justify-content-start"
                  >
                    <div
                      class="d-flex flex-row position-relative align-items-baseline"
                      style="width: 70%"
                    >
                      <label for="title" class="text-center mr-2 pl-2"
                        >Title:</label
                      >
                      <v-text-field
                        v-model="button1.title"
                        type="text"
                        class="recurringBtnWidth pt-0"
                        dense
                        placeholder="Button 1"
                        counter
                        solo
                      ></v-text-field>
                      <Emoji
                        :topStyleBlock="30"
                        :rightStyleBlock="76"
                        :topStyleIcon="5"
                        :rightStyleIcon="135"
                        @addEmoji="(emoji) => (this.button1.title += emoji)"
                      />
                      <span
                        class="font-weight-bolder text-decoration-underline"
                      >
                        Button 1
                      </span>
                    </div>
                  </div>
                  <div
                    :key="1"
                    v-if="shwBtn2"
                    class="d-flex justify-content-start pl-2 mt-5"
                  >
                    <div
                      class="d-flex flex-row position-relative align-items-baseline"
                      style="width: 70%"
                    >
                      <label for="title" class="text-center mr-2">Title:</label>
                      <v-text-field
                        v-model="button2.title"
                        type="text"
                        class="recurringBtnWidth pt-0"
                        dense
                        placeholder="Button 2"
                        counter
                        solo
                      ></v-text-field>
                      <Emoji
                        :topStyleBlock="30"
                        :rightStyleBlock="76"
                        :topStyleIcon="5"
                        :rightStyleIcon="135"
                        @addEmoji="(emoji) => (this.button2.title += emoji)"
                      />
                      <span
                        class="font-weight-bolder text-decoration-underline"
                      >
                        Button 2
                      </span>
                    </div>
                  </div>
                </transition-group>
              </div>
              <!-- Set Notification Expiry -->
              <div class="form-group d-flex flex-column">
                <div class="d-flex flex-row">
                  <div class="d-flex flex-row-reverse justify-content-end">
                    <label for="expiry" class="font-weight-bolder ml-2"
                      >Send Notification Expiry</label
                    >
                  </div>
                  <div class="select-group">
                    <input
                      type="number"
                      class="border ml-2"
                      id="ttl"
                      v-model="ttl"
                    />
                  </div>
                </div>
                <small class="ml-2">Default - 2 hours (7200 seconds)</small>
              </div>
            </div>
            <!-- Audience Settings -->
            <div
              style="border-top: 1px solid #5c4a4a17; margin: auto !important"
            >
              <h4 class="mt-3">Audience Settings</h4>
              <!-- Select Domain -->
              <div class="form-group d-flex flex-column form-check">
                <div class="d-flex flex-row">
                  <label
                    class="form-check-label"
                    :class="{ errorFontColor: error }"
                    for="domain"
                  >
                    Select Domain To Get Audience List
                    <em class="asterisk">*</em>
                  </label>
                </div>
                <div class="overflow-hidden">
                  <transition
                    enter-active-class="animate__animated animate__slideInDown animate__faster"
                    leave-active-class="animate__animated animate__slideOutUp animate__faster"
                    class="animate__faster"
                  >
                    <div>
                      <select
                        name="domain"
                        id=""
                        class="border px-3 text-left"
                        v-model="selectedDomainForGettingAudience"
                      >
                        <option
                          v-for="domain in domains"
                          :value="domain['id']"
                          :key="domain['id']"
                        >
                          {{ domain.url }}
                        </option>
                      </select>
                    </div>
                  </transition>
                </div>
              </div>

              <!-- Select Audience -->
              <div
                class="form-group d-flex flex-column form-check"
                v-if="selectedDomainForGettingAudience"
              >
                <div class="d-flex flex-row">
                  <label
                    class="form-check-label"
                    :class="{ errorFontColor: error }"
                    for="audience"
                  >
                    Select Audience
                    <em class="asterisk">*</em>
                  </label>
                </div>
                <div class="overflow-hidden">
                  <transition
                    enter-active-class="animate__animated animate__slideInDown animate__faster"
                    leave-active-class="animate__animated animate__slideOutUp animate__faster"
                    class="animate__faster"
                  >
                    <div>
                      <select
                        name="audience"
                        id=""
                        class="border px-3 text-left"
                        v-model="selectedAudience"
                      >
                        <option
                          v-for="filter in filters"
                          :value="filter"
                          :key="filter['id']"
                        >
                          {{ filter.name }}
                        </option>
                      </select>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <!-- Schedule -->
            <div
              style="border-top: 1px solid #5c4a4a17; margin: auto !important"
            >
              <h4 class="mt-3">Schedule</h4>
              <!-- Schedule Notification -->
              <div
                class="form-group form-check position-relative overflow-hidden"
              >
                <div class="d-flex flex-row-reverse justify-content-end">
                  <label
                    class="form-check-label"
                    :class="{ errorFontColor: error }"
                    for="schednotif"
                  >
                    Schedule Notification
                    <em class="asterisk">*</em>
                  </label>
                </div>
                <div>
                  <select
                    name="time"
                    class="border position-absolute w-80 px-1"
                    style="top: 0; right: 0"
                    v-model="selectedNotifType"
                  >
                    <option value="one" disabled>One Time</option>
                    <option value="multiple" disabled>Multiple Times</option>
                    <option value="recurring">Recurring</option>
                  </select>
                </div>
                <!-- One Time Type -->
                <div
                  v-if="selectedNotifType === 'one'"
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <label for="">
                    <strong>Choose Time:</strong>
                  </label>
                  <!-- Date Picker -->
                  <div class="form-group" style="margin-left: -34px" data-app>
                    <v-row>
                      <v-col>
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value="
                            one[0].schedule.choose_time[0].date_start
                          "
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="
                                one[0].schedule.choose_time[0].date_start
                              "
                              label="Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="one[0].schedule.choose_time[0].date_start"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal = false">
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.dialog.save(
                                  one[0].schedule.choose_time[0].date_start
                                );
                                modal = false;
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- Time Picker -->
                  <div class="form-group" style="margin-left: -34px" data-app>
                    <v-row>
                      <v-col>
                        <v-dialog
                          ref="dialog2"
                          v-model="modal2"
                          :return-value="one[0].schedule.choose_time[0].time"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="one[0].schedule.choose_time[0].time"
                              label="Time"
                              prepend-icon="mdi-clock-time-four-outline"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="modal2"
                            v-model="one[0].schedule.choose_time[0].time"
                            full-width
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal2 = false">
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.dialog2.save(
                                  one[0].schedule.choose_time[0].time
                                )
                              "
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- TimeZone -->
                  <div>
                    <v-combobox
                      v-model="one[0].schedule.choose_time[0].timezone"
                      :items="timezones"
                      hide-selected
                      outlined
                      dense
                      hint="Mandatory field"
                      persistent-hint
                    ></v-combobox>
                  </div>
                </div>
                <!-- Recurring Type -->
                <div
                  v-if="selectedNotifType === 'recurring'"
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <div class="my-4">
                    <label for="freq" class="mr-3"
                      ><strong>Frequency</strong></label
                    >
                    <select
                      name="freq"
                      v-model="recurring[0].schedule.frequency"
                    >
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                      <option value="monthly">Monthly</option>
                      <option value="yearly">Yearly</option>
                    </select>
                  </div>
                  <!-- Start Date Picker -->
                  <div class="form-group" style="margin-left: -34px" data-app>
                    <v-row>
                      <v-col>
                        <v-dialog
                          ref="start"
                          v-model="modalStart"
                          :return-value="recurring[0].schedule.date_start"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="recurring[0].schedule.date_start"
                              label="Start Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="recurring[0].schedule.date_start"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modalStart = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.start.save(
                                  recurring[0].schedule.date_start
                                );
                                modalStart = false;
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- End Date Picker -->
                  <div class="form-group" style="margin-left: -34px" data-app>
                    <v-row>
                      <v-col>
                        <v-dialog
                          ref="end"
                          v-model="modalEnd"
                          :return-value="recurring[0].schedule.date_end"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="recurring[0].schedule.date_end"
                              label="End Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="recurring[0].schedule.date_end"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modalEnd = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.end.save(recurring[0].schedule.date_end);
                                modalEnd = false;
                              "
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- Time Picker -->
                  <div class="form-group" style="margin-left: -34px" data-app>
                    <v-row>
                      <v-col>
                        <v-dialog
                          ref="dialogTime"
                          v-model="modalTime"
                          :return-value="recurring[0].schedule.time"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="recurring[0].schedule.time"
                              label="Time"
                              prepend-icon="mdi-clock-time-four-outline"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="modalTime"
                            v-model="recurring[0].schedule.time"
                            full-width
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="modalTime = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.dialogTime.save(
                                  recurring[0].schedule.time
                                )
                              "
                            >
                              OK
                            </v-btn>
                          </v-time-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- TimeZone -->
                  <div>
                    <v-combobox
                      v-model="recurring[0].schedule.timezone"
                      :items="timezones"
                      hide-selected
                      outlined
                      dense
                      hint="Mandatory field"
                      persistent-hint
                    ></v-combobox>
                  </div>
                </div>
                <!-- Multiple Times Type -->
                <div v-if="selectedNotifType === 'multiple'">
                  <div
                    class="my-3 d-flex flex-column align-items-center justify-content-center"
                    v-for="(item, i) in multiple[0].schedule.choose_time"
                    :key="i"
                  >
                    <div>
                      <label for="">
                        <strong>Choose Time:</strong>
                      </label>
                      <em
                        v-show="i"
                        @click="removeMultipleSchedule(value)"
                        class="mx-3"
                        style="cursor: pointer; font-size: 21px"
                        >&times;</em
                      >
                    </div>
                    <!-- Date Picker -->
                    <div class="form-group" style="margin-left: -34px" data-app>
                      <v-row>
                        <v-col>
                          <v-dialog
                            ref="multiple"
                            v-model="modal"
                            :return-value="item.date_start"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="item.date_start"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="item.date_start" scrollable>
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modal = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.multiple[i].save(item.date_start);
                                  modal = false;
                                "
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-col>
                      </v-row>
                    </div>
                    <!-- Time Picker -->
                    <div class="form-group" style="margin-left: -34px" data-app>
                      <v-row>
                        <v-col>
                          <v-dialog
                            ref="dialog2"
                            v-model="modal2"
                            :return-value="item.time"
                            persistent
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="item.time"
                                label="Time"
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="modal2"
                              v-model="item.time"
                              full-width
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="modal2 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog2[i].save(item.time)"
                              >
                                OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                      </v-row>
                    </div>
                    <!-- TimeZone -->
                    <div>
                      <v-combobox
                        v-model="item.timezone"
                        :items="timezones"
                        hide-selected
                        outlined
                        dense
                        hint="Mandatory field"
                        persistent-hint
                      ></v-combobox>
                    </div>
                    <button
                      class="btn btn-sm btn-primary mt-3"
                      @click="addMultipleSchedule"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Domains for selecting to create drips -->
            <div
              style="border-top: 1px solid #5c4a4a17; margin: auto !important"
            >
              <h4 class="mt-3">Domains</h4>
              <!-- Select Audience -->
              <div class="form-group d-flex flex-column form-check">
                <div class="overflow-hidden">
                  <transition
                    enter-active-class="animate__animated animate__slideInDown animate__faster"
                    leave-active-class="animate__animated animate__slideOutUp animate__faster"
                    class="animate__faster"
                  >
                    <div>
                      <!-- Select Domains Dropdown -->
                      <div
                        class="d-flex align-items-center h-100"
                        style="top: 0; right: 142px; max-height: 200px"
                      >
                        <v-menu
                          bottom
                          :close-on-content-click="false"
                          id="select_domains_dropdown"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="#007bff"
                              style="font-size: 12px"
                              dark
                              v-bind="attrs"
                              v-on="on"
                            >
                              Select Domain(s)
                            </v-btn>
                          </template>
                          <v-text-field
                            v-model="search"
                            placeholder="Search by tags"
                            class="ml-5"
                            style="width: 70%"
                          ></v-text-field>
                          <small
                            class="ml-5 position-absolute"
                            style="top: 21px; right: 21px"
                          >
                            {{ selectedTags.length }}
                          </small>
                          <v-treeview
                            selectable
                            :search="search"
                            :items="tags"
                            @update:open="onOpen"
                            v-model="selectedTags"
                          >
                            <template #label="{ item }">
                              <span style="cursor: pointer">{{
                                item.name
                              }}</span>
                            </template></v-treeview
                          >
                        </v-menu>
                        <em class="asterisk">*</em>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <!-- Buttons Group -->
            <div class="text-center mb-4">
              <button
                @click="
                  if (selectedAudience && selectedTags.length) {
                    //this.onSelected(selectedTags);
                    selectedDomains = onSelected(selectedTags);
                    create($event);
                  } else {
                    failure = true;
                  }
                "
                class="btn btn-xl btn-success border-radius-unset m-0 mr-4 mt-4"
                id="save_btn"
              >
                Save
              </button>
              <button
                class="btn btn-xl btn-light border-radius-unset m-0 mr-4 mt-4"
                id="save_draft_btn"
                @click="
                  if (selectedAudience && selectedTags.length) {
                    selectedDomains = onSelected(selectedTags);
                    create($event);
                  } else {
                    failure = true;
                  }
                "
              >
                Save Draft
              </button>
            </div>
          </div>
          <!-- Preview -->
          <div class="col-md-6 col-xs-12">
            <div
              class="w-100 overflow-hidden position-relative"
              style="
                min-height: 88px;
                border: 4px solid #dfe1e5;
                border-radius: 4px;
                padding: 50px 25px 18px 25px;
                box-shadow: #3f3f3f8f 1px 5px 7px 1px;
              "
            >
              <div
                class="w-100 position-absolute d-flex justify-content-between preview-header align-items-center"
                style="
                  top: 0;
                  right: 0;
                  height: 25px !important;
                  background: #dad9d9 !important;
                "
              >
                <div class="d-flex justify-content-start">
                  <div class="overflow-hidden" style="margin-bottom: 2px">
                    <svg
                      width="7"
                      height="7"
                      viewBox="0 0 7 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_i_172_618)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3.724 6.7945C5.41989 6.7945 6.79468 5.41971 6.79468 3.72382C6.79468 2.02793 5.41989 0.653137 3.724 0.653137C2.02811 0.653137 0.65332 2.02793 0.65332 3.72382C0.65332 5.41971 2.02811 6.7945 3.724 6.7945Z"
                          fill="#ED6A5E"
                        />
                      </g>
                      <path
                        d="M6.66674 3.72382C6.66674 5.34905 5.34923 6.66655 3.724 6.66655C2.09877 6.66655 0.781265 5.34905 0.781265 3.72382C0.781265 2.09859 2.09877 0.781082 3.724 0.781082C5.34923 0.781082 6.66674 2.09859 6.66674 3.72382Z"
                        stroke="#CE5347"
                        stroke-width="0.25589"
                      />
                      <defs>
                        <filter
                          id="filter0_i_172_618"
                          x="0.65332"
                          y="0.653137"
                          width="6.1416"
                          height="6.14136"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset />
                          <feGaussianBlur stdDeviation="1.53534" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect1_innerShadow_172_618"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <svg
                      width="8"
                      height="7"
                      viewBox="0 0 8 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_i_172_619)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3.95935 6.7945C5.65524 6.7945 7.03003 5.41971 7.03003 3.72382C7.03003 2.02793 5.65524 0.653137 3.95935 0.653137C2.26346 0.653137 0.888672 2.02793 0.888672 3.72382C0.888672 5.41971 2.26346 6.7945 3.95935 6.7945Z"
                          fill="#F6BE4F"
                        />
                      </g>
                      <path
                        d="M6.90209 3.72382C6.90209 5.34905 5.58458 6.66655 3.95935 6.66655C2.33412 6.66655 1.01662 5.34905 1.01662 3.72382C1.01662 2.09859 2.33412 0.781082 3.95935 0.781082C5.58458 0.781082 6.90209 2.09859 6.90209 3.72382Z"
                        stroke="#D6A243"
                        stroke-width="0.25589"
                      />
                      <defs>
                        <filter
                          id="filter0_i_172_619"
                          x="0.888672"
                          y="0.653137"
                          width="6.1416"
                          height="6.14136"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset />
                          <feGaussianBlur stdDeviation="1.53534" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect1_innerShadow_172_619"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <svg
                      width="7"
                      height="7"
                      viewBox="0 0 7 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_i_172_620)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3.19568 6.7945C4.89157 6.7945 6.26636 5.41971 6.26636 3.72382C6.26636 2.02793 4.89157 0.653137 3.19568 0.653137C1.49979 0.653137 0.125 2.02793 0.125 3.72382C0.125 5.41971 1.49979 6.7945 3.19568 6.7945Z"
                          fill="#62C554"
                        />
                      </g>
                      <path
                        d="M6.13842 3.72382C6.13842 5.34905 4.82091 6.66655 3.19568 6.66655C1.57045 6.66655 0.252945 5.34905 0.252945 3.72382C0.252945 2.09859 1.57045 0.781082 3.19568 0.781082C4.82091 0.781082 6.13842 2.09859 6.13842 3.72382Z"
                        stroke="#58A942"
                        stroke-width="0.25589"
                      />
                      <defs>
                        <filter
                          id="filter0_i_172_620"
                          x="0.125"
                          y="0.653137"
                          width="6.1416"
                          height="6.14136"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset />
                          <feGaussianBlur stdDeviation="1.53534" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect1_innerShadow_172_620"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                  <div>
                    <span style="height: 15px !important">
                      <svg
                        width="4"
                        height="7"
                        viewBox="0 0 4 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.56902 6.36268L1.05448 3.84813C1.03814 3.83181 1.02517 3.81244 1.01633 3.7911C1.00748 3.76977 1.00293 3.7469 1.00293 3.72381C1.00293 3.70072 1.00748 3.67785 1.01633 3.65652C1.02517 3.63519 1.03814 3.61581 1.05448 3.59949L3.56902 1.08495"
                          stroke="#575757"
                          stroke-width="0.76767"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span>
                      <svg
                        width="5"
                        height="7"
                        viewBox="0 0 5 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.30988 6.36268L3.82443 3.84813C3.84077 3.83181 3.85373 3.81244 3.86258 3.7911C3.87142 3.76977 3.87598 3.7469 3.87598 3.72381C3.87598 3.70072 3.87142 3.67785 3.86258 3.65652C3.85373 3.63519 3.84077 3.61581 3.82443 3.59949L1.30988 1.08495"
                          stroke="#ADADAD"
                          stroke-width="0.76767"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div>
                    <span>
                      <svg
                        width="9"
                        height="7"
                        viewBox="0 0 9 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.9325 0.653137C8.21515 0.653137 8.44428 0.882269 8.44428 1.16492V6.28272C8.44428 6.56537 8.21515 6.7945 7.9325 6.7945H1.27936C0.99671 6.7945 0.767578 6.56537 0.767578 6.28272V1.16492C0.767578 0.882269 0.99671 0.653137 1.27936 0.653137H7.9325ZM3.83826 1.16492H7.9325V6.28272H3.83826V1.16492ZM3.32648 6.28272H1.27936L1.27936 1.16492H3.32648V6.28272Z"
                          fill="#585758"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <div class="preview-header--search-input">
                  <span>
                    <svg
                      width="5"
                      height="6"
                      viewBox="0 0 5 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.16412 2.83835H0.652344V5.90903H4.74658V2.83835H4.2348V2.32657C4.2348 1.47862 3.54741 0.791229 2.69946 0.791229C1.85152 0.791229 1.16412 1.47862 1.16412 2.32657V2.83835ZM1.6759 2.83835H3.72302V2.32657C3.72302 1.76127 3.26476 1.30301 2.69946 1.30301C2.13417 1.30301 1.6759 1.76127 1.6759 2.32657V2.83835Z"
                        fill="#A09FA0"
                      />
                    </svg>
                  </span>
                  <span style="font-size: 5px">{{
                    selectedDomain($route.params.id)
                  }}</span>
                  <span>
                    <svg
                      width="7"
                      height="8"
                      viewBox="0 0 7 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.33722 3.35962L5.64023 1.91917L3.33722 0.478729V1.5468C1.90259 1.67609 0.77832 2.88182 0.77832 4.35013C0.77832 5.90468 2.03853 7.16492 3.59311 7.16492C5.14769 7.16492 6.4079 5.90468 6.4079 4.35013V4.09424H5.89612V4.35013C5.89612 5.62205 4.86506 6.65314 3.59311 6.65314C2.32116 6.65314 1.2901 5.62205 1.2901 4.35013C1.2901 3.1647 2.18572 2.18846 3.33722 2.06117V3.35962Z"
                        fill="#7B7C7C"
                      />
                    </svg>
                  </span>
                </div>
                <div class="d-flex">
                  <div>
                    <svg
                      width="7"
                      height="9"
                      viewBox="0 0 7 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.69328 2.58193C4.78225 2.69172 4.94343 2.70859 5.05313 2.61963C5.16296 2.53064 5.17982 2.36952 5.09086 2.25969L3.87176 0.755336C3.85652 0.7365 3.83903 0.718821 3.81928 0.702921C3.80192 0.688958 3.78267 0.67637 3.76181 0.665687C3.73282 0.650819 3.70133 0.640136 3.66835 0.634388C3.65011 0.631233 3.63149 0.629578 3.61262 0.629578C3.5594 0.629578 3.50842 0.642635 3.46344 0.665687C3.41871 0.688521 3.38197 0.720008 3.35336 0.755336L2.13438 2.25969C2.04542 2.36949 2.06229 2.53064 2.17212 2.61963C2.28182 2.70859 2.443 2.69172 2.53196 2.58193L3.35673 1.56414V5.74738H3.86851V1.56414L4.69328 2.58193Z"
                        fill="#575757"
                      />
                      <path
                        d="M3.86853 3.18848H3.35675V3.70026H3.86853V3.18848Z"
                        fill="#575757"
                      />
                      <path
                        d="M4.38031 3.70026H5.91565V7.7945H1.30963V3.70026H2.84497V3.18848H1.30963C1.027 3.18848 0.797852 3.4176 0.797852 3.70026V7.7945C0.797852 8.07716 1.027 8.30628 1.30963 8.30628H5.91565C6.19828 8.30628 6.42743 8.07716 6.42743 7.7945V3.70026C6.42743 3.4176 6.19828 3.18848 5.91565 3.18848H4.38031V3.70026Z"
                        fill="#575757"
                      />
                    </svg>
                  </div>
                  <div>
                    <svg
                      width="7"
                      height="7"
                      viewBox="0 0 7 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.20282 1.16492H2.62036V1.6767H2.10858V1.16492C2.10858 0.882258 2.33773 0.653137 2.62036 0.653137H6.20282C6.48545 0.653137 6.7146 0.882258 6.7146 1.16492V4.74738C6.7146 5.03004 6.48545 5.25916 6.20282 5.25916H5.69104V4.74738H6.20282V1.16492Z"
                        fill="#575757"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.573242 2.70026C0.573242 2.4176 0.802394 2.18848 1.08502 2.18848H4.66748C4.95011 2.18848 5.17926 2.4176 5.17926 2.70026V6.28272C5.17926 6.56538 4.95011 6.7945 4.66748 6.7945H1.08502C0.802394 6.7945 0.573242 6.56538 0.573242 6.28272V2.70026ZM1.08502 2.70026H4.66748V6.28272H1.08502V2.70026Z"
                        fill="#575757"
                      />
                    </svg>
                  </div>
                  <div>
                    <svg
                      width="7"
                      height="7"
                      viewBox="0 0 7 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.85974 0.723816H3.34796V3.28272H0.789062V3.7945H3.34796V6.3534H3.85974V3.7945H6.41864V3.28272H3.85974V0.723816Z"
                        fill="#646565"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-start">
                <em></em>
              </div>
              <div class="border overflow-hidden" style="min-height: 82px">
                <div class="d-flex flex-row mb-3">
                  <!-- Icon Image -->
                  <div class="overflow-hidden">
                    <img
                      v-if="recurringDrips !== undefined"
                      id="icon"
                      class="prev-icon-img animate__animated"
                      style="height: 80px; width: 80px !important"
                    />
                  </div>
                  <!-- Title & Message -->
                  <div
                    style="width: calc(100% - 80px)"
                    class="pl-2 pt-1 text-left overflow-y-scroll word-break hide-scrollbar"
                  >
                    <div class="font-weight-bolder" style="color: #4a5156">
                      {{ recurringDrips.title || "Title" }}
                    </div>
                    <div class="pb-1">
                      {{ recurringDrips.body || "Your message here ..." }}
                    </div>
                    <small class="pb-2">{{
                      selectedDomain($route.params.id)
                    }}</small>
                  </div>
                </div>
                <!-- Large Image -->
                <div class="overflow-hidden">
                  <transition
                    enter-active-class="animate__animated animate__slideInDown"
                    leave-active-class="animate__animated animate__slideOutUp"
                  >
                    <div v-if="shwLargeImg">
                      <img
                        id="lg_image"
                        style="
                          background: #fff;
                          height: auto;
                          margin-bottom: -10%;
                        "
                        class="w-100 prev-lg-img"
                      />
                    </div>
                  </transition>
                </div>
                <!-- Buttons Block -->
                <transition-group
                  tag="div"
                  class="btn-group d-flex flex-column"
                  enter-active-class="animate__animated animate__backInLeft animate__faster"
                  leave-active-class="animate__animated animate__backOutLeft animate__faster"
                >
                  <button
                    :key="0"
                    v-if="shwActionBtns"
                    id="btn_1"
                    class="border-bottom border-top color-black m-0 pl-3 py-1 text-center"
                    style="font-weight: 400 !important"
                  >
                    {{ button1.title || "Button1" }}
                  </button>
                  <button
                    :key="1"
                    v-if="shwBtn2"
                    id="btn_2"
                    class="color-black m-0 pl-3 py-1 text-center"
                    style="font-weight: 400 !important"
                  >
                    {{ button2.title || "Button2" }}
                  </button>
                </transition-group>
              </div>
            </div>
          </div>
          <transition
            class="animate__faster"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
          >
            <SuccessSnackbar
              v-if="success"
              @update-success="handleUpdateToSuccessSnackbar"
              :message="
                typeof recurringDrips.is_active !== undefined &&
                recurringDrips.is_active === 0
                  ? 'Draft Is Successfully Created!'
                  : 'Recurring Drip Is Successfully Created!'
              "
            />
          </transition>
          <!-- Error -->
          <Error v-if="error" :error="error" />
          <!-- Failure Snackbar -->
          <transition
            class="animate__faster"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
          >
            <FailureSnackbar
              v-if="failure || !scheduleDatesCompatibility"
              @update-failure="handleUpdateToFailureSnackbar"
              :message="
                failure
                  ? 'Fill the required fields out!'
                  : !scheduleDatesCompatibility
                  ? 'Fill the schedule dates properly!'
                  : ''
              "
            />
          </transition>
          <Spinner
            v-if="processLoading"
            class="loading-spinner--center"
            style="position: fixed !important"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import Tags from "../../apis/Tags";
import Domains from "../../apis/Domains";
import Error from "../popUps/Error.vue";
import Emoji from "../drip/EmojiPicker.vue";
import Spinner from "../popUps/Spinner.vue";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import common from "../../mixins/common";
import recurring from "../../mixins/recurring";

export default {
  name: "DripSetup",
  components: {
    Spinner,
    SuccessSnackbar,
    FailureSnackbar,
    Emoji,
    Error,
  },
  mixins: [common, recurring],
  data() {
    return {
      disabledValue: false,
    };
  },
  mounted() {
    window.addEventListener("popstate", () => {
      Object.assign(
        this.recurringDrips,
        this.$store.state.push.emptypushStructure
      );
    });

    Tags.show().then((response) => {
      this.tags = response.data.data.map((el) => ({
        id: el.id,
        name: el.name,
        children: [],
      }));

      this.tags.forEach((el, indx) => {
        Domains.searchByTags(`?tags[]=${el.name}`).then((response) => {
          if (response.data.data.length) {
            response.data.data.forEach((dmn) => {
              el.children.push({
                id: dmn.id.toString() + "." + el.id.toString(),
                domain_id: dmn.id,
                name: dmn.url,
              });
            });
          } else {
            this.tags.splice(indx, 1);
          }
        });
      });
    });

    this.one[0].schedule.choose_time[0].date_start = "";
    this.one[0].schedule.choose_time[0].time = "";
    this.one[0].schedule.choose_time[0].timezone = "";

    this.recurring[0].schedule.date_start = "";
    this.recurring[0].schedule.date_end = "";
    this.recurring[0].schedule.time = "";
    this.recurring[0].schedule.timezone = "";
    this.recurring[0].schedule.frequency = "daily";

    this.multiple[0].schedule.choose_time = [];
    this.multiple[0].schedule.choose_time.push({
      date_start: "",
      time: "",
      timezone: "",
    });
  },
  beforeDestroy() {
    window.removeEventListener("popstate", () => {
      Object.assign(
        this.recurringDrips,
        this.$store.state.push.emptypushStructure
      );
    });
  },
  methods: {
    onOpen(e) {
      if (!this.__initial) {
        this.__initial = true;
        return;
      }
    },
    onSelected(e) {
      e.forEach((el, i) => {
        if (typeof el === "string") {
          e[i] = el.split(".")[0];
          e[i] = parseInt(el);
        }
      });

      return e;
    },
  },
};
</script>

<style scoped>
*::-webkit-scrollbar {
  display: none !important;
}
*::-moz-scrollbar {
  display: none !important;
}
*::-ms-scrollbar {
  display: none !important;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.word-break {
  word-break: break-word;
}
.prev-lg-img,
.prev-icon-img {
  background-size: cover !important;
}
.v-text-field__slot > input {
  width: 100px !important;
}
button.v-icon {
  color: #c6c6c6 !important;
}
input[type="checkbox"] {
  height: 12px;
  width: 12px;
  margin: 6px;
}
.height-180 {
  height: 180px !important;
}
.blue {
  background: #0075ff;
}
.color-black {
  color: black !important;
}
.justify-content-evenly {
  justify-content: space-evenly !important;
}
.w-80 {
  width: 80px !important;
}
.width-min {
  width: min-content !important;
}
.blue-bg {
  background: #3077ac;
}
.font-color-white {
  color: #fff !important;
}
.border-radius-unset {
  border-radius: unset !important;
}
.preview-header {
  border-bottom: 1px solid #bdbebe;
}
.preview-header div:nth-child(1) div + div {
  margin: 0 7px;
}
.preview-header div:nth-child(1) div svg {
  margin: 0 1.5px;
}
.preview-header div div:nth-child(2) {
  display: flex;
  align-items: center;
}
.preview-header div div:nth-child(2) span {
  background: linear-gradient(180deg, #fdfdfd 0%, #f3f3f3 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 15px;
  width: 15px;
  border-radius: 2.5px;
}
.preview-header div div:nth-child(2) span:nth-child(1) {
  margin-right: 1px;
}
.preview-header div div:nth-child(2) span:nth-child(2) {
  padding: 3px 3px 3px 5px;
}
.preview-header div:nth-child(1) div:nth-child(3),
.preview-header div:nth-child(3) div,
.preview-header div:nth-child(3),
.preview-header div:nth-child(2),
.preview-header div:nth-child(2) span:nth-child(1),
.preview-header div:nth-child(2) span:nth-child(3),
.preview-header div:nth-child(1) div:nth-child(3) span {
  display: flex;
  align-items: center;
}
.preview-header div:nth-child(1) div:nth-child(3) {
  margin: 0 !important;
}
.preview-header div:nth-child(1) div:nth-child(3) span,
.preview-header div:nth-child(3) div {
  background: linear-gradient(180deg, #fdfdfd 0%, #f3f3f3 100%);
}
.preview-header div:nth-child(1) div:nth-child(3) span {
  padding: 0 6px;
  border-radius: 2px;
  height: 15px !important;
}
.preview-header div:nth-child(3) div:nth-child(1) {
  padding: 0 6px;
  height: 12px;
  margin: 0 4px;
  border-radius: 2px;
}
.preview-header div:nth-child(3) div:nth-child(2) {
  padding: 0 6px;
  height: 12px;
  margin: 0 4px 0 0;
  border-radius: 2px;
}
.preview-header div:nth-child(3) div:nth-child(3) {
  background: #bdbebe;
  padding: 0 3px;
  height: 14px;
  display: flex;
  align-items: center;
  margin-bottom: -12px;
}
.preview-header div:nth-child(2) span:nth-child(1) {
  height: 8px;
  margin-right: 3px;
}
.preview-header div:nth-child(2) span:nth-child(2) {
  font-size: 5px;
  color: #4c4c4c;
}
.preview-header div:nth-child(2) span:nth-child(3) {
  position: absolute;
  right: 2px;
  height: 10px;
}
.row.mb-2 {
  height: 70px;
}
</style>